"use strict";

exports.__esModule = true;
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _form2js = _interopRequireDefault(require("./form2js"));

var _request = _interopRequireDefault(require("./request"));

var _ini_set = _interopRequireDefault(require("locutus/php/info/ini_set"));

var _is_array = _interopRequireDefault(require("locutus/php/var/is_array"));

var _is_null = _interopRequireDefault(require("locutus/php/var/is_null"));

var _is_object = _interopRequireDefault(require("locutus/php/var/is_object"));

var _is_bool = _interopRequireDefault(require("locutus/php/var/is_bool"));

var _is_int = _interopRequireDefault(require("locutus/php/var/is_int"));

var _is_numeric = _interopRequireDefault(require("locutus/php/var/is_numeric"));

var _empty = _interopRequireDefault(require("locutus/php/var/empty"));

var _is_string = _interopRequireDefault(require("locutus/php/var/is_string"));

var _date = _interopRequireDefault(require("locutus/php/datetime/date"));

var _time = _interopRequireDefault(require("locutus/php/datetime/time"));

var _strtotime = _interopRequireDefault(require("locutus/php/datetime/strtotime"));

var _parse_url = _interopRequireDefault(require("locutus/php/url/parse_url"));

var _http_build_query = _interopRequireDefault(require("locutus/php/url/http_build_query"));

var _parse_str = _interopRequireDefault(require("locutus/php/strings/parse_str"));

var _md = _interopRequireDefault(require("locutus/php/strings/md5"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//import serialize from 'locutus/php/var/serialize';
//import utf8_encode from 'locutus/php/xml/utf8_encode';
//import urlencode from 'locutus/php/url/urlencode';
//import urldecode from 'locutus/php/url/urldecode';
//import str_pad from 'locutus/php/strings/str_pad';
//import wordwrap from 'locutus/php/strings/wordwrap';
//import sort from 'locutus/php/array/sort';
//import ksort from 'locutus/php/array/ksort';
//import dencrypt from './dencrypt'
//import count from 'locutus/php/array/count';
(0, _ini_set.default)('locutus.objectsAsArrays', 0);

var tools = function tools() {};

var mimeType = {
  'cal': 'image/x-cals',
  'cod': 'image/cis-cod',
  'dcx': 'image/x-dcx',
  'eri': 'image/x-eri',
  'fh4': 'image/x-freehand',
  'fh5': 'image/x-freehand',
  'fhc': 'image/x-freehand',
  'fif': 'image/fif',
  'fpx': 'image/x-fpx',
  'gif': 'image/gif',
  'ief': 'image/ief',
  'ifm': 'image/gif',
  'ifs': 'image/ifs',
  'j2k': 'image/j2k',
  'jpg': 'image/jpeg',
  'jpeg': 'image/jpeg',
  'map': 'magnus-internal/imagemap',
  'mil': 'image/x-cals',
  'nbmp': 'image/nbmp',
  'nokia-op-logo': 'image/vnd.nok-oplogo-color',
  'pbm': 'image/x-portable-bitmap',
  'pcx': 'image/x-pcx',
  'pda': 'image/x-pda',
  'pgm': 'image/x-portable-graymap',
  'pict': 'image/x-pict',
  'png': 'image/png',
  'pnm': 'image/x-portable-anymap',
  'pnz': 'image/png',
  'ppm': 'image/x-portable-pixmap',
  'qti': 'image/x-quicktime',
  'qtif': 'image/x-quicktime',
  'ras': 'image/x-cmu-raster',
  'rf': 'image/vnd.rn-realflash',
  'rgb': 'image/x-rgb',
  'rp': 'image/vnd.rn-realpix',
  'si6': 'image/si6',
  'si7': 'image/vnd.stiwap.sis',
  'si9': 'image/vnd.lgtwap.sis',
  'svf': 'image/vnd',
  'svg': 'image/svg-xml',
  'svh': 'image/svh',
  'tif': 'image/tiff',
  'tiff': 'image/tiff',
  'toy': 'image/toy',
  'wbmp': 'image/vnd.wap.wbmp',
  'wi': 'image/wavelet',
  'wpng': 'image/x-up-wpng',
  'xbm': 'image/x-xbitmap',
  'xpm': 'image/x-xpixmap',
  'xwd': 'image/x-xwindowdump'
};
/**
 * 单位转换
 * @param str
 * @param type
 * @return {*}
 */

var translateScalars = function translateScalars(str, type) {
  if (type === void 0) {
    type = 1;
  }

  if (type == 1) {
    str = str.toString();

    if (str.search(/k/i) === str.length - 1) {
      return parseFloat(str.substring(0, str.length - 1) * 1024);
    } else if (str.search(/m/i) === str.length - 1) {
      return parseFloat(str.substring(0, str.length - 1) * 1048576);
    } else if (str.search(/g/i) === str.length - 1) {
      return parseFloat(str.substring(0, str.length - 1) * 1073741824);
    } else if (str.search(/b/i) === str.length - 1) {
      return parseFloat(str.substring(0, str.length - 1));
    }

    return str;
  } else {
    var bytes = parseInt(str);
    if (bytes === 0) return '0 B';
    var k = 1024;
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
  }
};

var mime2type = function mime2type(type) {
  for (var i in mimeType) {
    if (type === mimeType[i]) return i;
  }

  return type;
}; //const getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
//    return placement == 'bottom' ? {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2} :
//        placement == 'top' ? {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2} :
//            placement == 'left' ? {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth} :
//                /* placement == 'right' */ {
//                    top: pos.top + pos.height / 2 - actualHeight / 2,
//                    left: pos.left + pos.width
//                }
//
//};


var _scrollbarWidth = 0;

var scrollbarWidth = function scrollbarWidth() {
  if (_scrollbarWidth) return _scrollbarWidth;
  var scrollDiv = document.createElement('div');
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  scrollDiv.remove();
  return _scrollbarWidth = scrollbarWidth;
};

var getPosition = function getPosition(elem) {
  var $element = (0, _jquery.default)(elem);
  var el = $element[0];
  var isBody = el.tagName == 'BODY';
  var elRect = el.getBoundingClientRect();

  if (elRect.width == null) {
    // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
    elRect = _jquery.default.extend({}, elRect, {
      width: elRect.right - elRect.left,
      height: elRect.bottom - elRect.top
    });
  }

  var elOffset = isBody ? {
    top: 0,
    left: 0
  } : $element.offset();
  var scroll = {
    scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()
  };
  var outerDims = isBody ? {
    width: (0, _jquery.default)(window).width(),
    height: (0, _jquery.default)(window).height()
  } : null;
  return _jquery.default.extend({}, elRect, scroll, outerDims, elOffset);
};

var is_function = function is_function(mixedVar) {
  return typeof mixedVar === 'function';
};

var uuid = function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == "x" ? r : r & 3 | 8;
    return v.toString(16);
  }).toUpperCase();
};

var orderCode = function orderCode(str) {
  if (str === void 0) {
    str = '';
  }

  return (0, _md.default)(str + this.uuid()).toUpperCase().substr(8, 16);
}; //const jhid = function () {
//    return "JH" + md5(uuid()).toUpperCase();
//};


var transTree = function transTree(a, idStr, pidStr, childrenStr) {
  var r = [],
      hash = {},
      id = idStr || 'id',
      pid = pidStr || 'pid',
      children = childrenStr || 'children',
      i = 0,
      j = 0,
      len = a.length;

  for (i = 0; i < len; i++) {
    hash[a[i][id]] = a[i];
  }

  for (j = 0; j < len; j++) {
    var aVal = a[j],
        hashVP = hash[aVal[pid]];

    if (hashVP) {
      !hashVP[children] && (hashVP[children] = []);
      hashVP[children].push(aVal);
    } else {
      r.push(aVal);
    }
  }

  return r;
};
/**
 *
 * @param src
 * @param option
 * @returns {[]}
 */


var transTree2 = function transTree2(src, option) {
  if (src === void 0) {
    src = [];
  }

  if (option === void 0) {
    option = {};
  }

  var _option = option,
      _option$id = _option.id,
      id = _option$id === void 0 ? "id" : _option$id,
      _option$pid = _option.pid,
      pid = _option$pid === void 0 ? "pid" : _option$pid,
      _option$store = _option.store,
      store = _option$store === void 0 ? {} : _option$store;
  var result = [];
  var hash = {};

  for (var i in src) {
    hash[src[i][id]] = {
      data: src[i]
    };
    store[src[i][id]] = store[src[i][id]] || {};
  }

  var _loop = function _loop(j) {
    var val = src[j];
    var self = hash[val[id]];
    var self_store = store[val[id]];
    var self_up = hash[val[pid]];

    if (self_up) {
      self_up.children = self_up.children || [];
      self_up.children.push(self);
    } else {
      result.push(self);
    }

    self.store = function (name, value) {
      if (name == null && value == null) return self_store;
      return (0, _get.default)(self_store, name);
    };

    self.parent = function () {
      return self_up;
    };

    self.filter = function (callback) {
      var list = [];

      if (callback(val)) {
        list.push(self);
      }

      if (self.children) {
        self.children.forEach(function (chd) {
          list = list.concat(chd.filter(callback));
        });
      }

      return list;
    };

    self.level = function () {
      if (self_up) return self_up.level() + 1;else return 1;
    };

    self.path = function (name, join) {
      if (name === void 0) {
        name = 'id';
      }

      if (join === void 0) {
        join = '/';
      }

      var list = [];
      if (self_up) list = self_up.path(name, null);
      list.push(val[name]);
      if (join) return list.join(join);else return list;
    };
  };

  for (var j in src) {
    _loop(j);
  }

  return result;
}; //const clone = function (obj) {
//    var o;
//    if (typeof obj == "object") {
//        if (obj === null) {
//            o = null;
//        } else {
//            if (obj instanceof Array) {
//                o = [];
//                for (var i = 0, len = obj.length; i < len; i++) {
//                    o.push(clone(obj[i]));
//                }
//            } else {
//                o = {};
//                for (var j in obj) {
//                    o[j] = clone(obj[j]);
//                }
//            }
//        }
//    } else {
//        o = obj;
//    }
//    return o;
//}


var type = function type(obj) {
  return Object.prototype.toString.call(obj);
};
/**
 *
 * @param urlData
 * @return {Blob}
 */


var base64ToBlob = function base64ToBlob(urlData) {
  var mimeString = urlData.split(',')[0].split(':')[1].split(';')[0]; // mime类型

  var byteString = atob(urlData.split(',')[1]); //base64 解码

  var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组

  var intArray = new Uint8Array(arrayBuffer); //创建视图

  for (var i = 0; i < byteString.length; i += 1) {
    intArray[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([intArray], {
    type: mimeString
  }); //转成blob

  return blob;
};
/**
 * 图片压缩
 * @param image
 * @param scale
 * @param type
 * @return {Blob}
 */


var resize = function resize(image, scale, type) {
  var canvas = document.createElement('canvas');
  canvas.width = image.width * scale;
  canvas.height = image.height * scale;
  var context = canvas.getContext('2d');
  context.clearRect(0, 0, image.width, image.height);
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  var data = canvas.toDataURL(type);
  return base64ToBlob(data);
};
/**
 * 价格格式化
 * @param val
 * @param type
 * @param fixed
 * @return {string | number}
 */


var price = function price(val, type, fixed) {
  if (type === void 0) {
    type = 100;
  }

  if (fixed === void 0) {
    fixed = 2;
  }

  type = type * 1 || 100;
  return ((0, _is_numeric.default)(val) ? val / type : 0).toFixed(fixed) || 0;
};

tools.prototype.emptyFunc = function () {};

tools.prototype.href = 'javascript:void(0);';
tools.prototype.mimeType = mimeType;
tools.prototype.form2js = _form2js.default;
tools.prototype.scrollbarWidth = scrollbarWidth;
tools.prototype.getPosition = getPosition; //tools.prototype.getCalculatedOffset = getCalculatedOffset;

tools.prototype.is_function = is_function;
tools.prototype.date = _date.default;
tools.prototype.time = _time.default;

tools.prototype.strtotime = function (text, now) {
  if (!text) return false;
  return (0, _strtotime.default)(text, now);
};

tools.prototype.empty = _empty.default;
tools.prototype.is_string = _is_string.default;
tools.prototype.is_array = _is_array.default;
tools.prototype.is_null = _is_null.default;
tools.prototype.is_object = _is_object.default;
tools.prototype.is_bool = _is_bool.default;
tools.prototype.is_int = _is_int.default; //tools.prototype.utf8_encode = utf8_encode;

tools.prototype.parse_str = _parse_str.default; //tools.prototype.str_pad = str_pad

tools.prototype.parse_url = _parse_url.default;
tools.prototype.md5 = _md.default; //tools.prototype.urlencode = urlencode;
//tools.prototype.urldecode = urldecode;

tools.prototype.http_build_query = _http_build_query.default; //tools.prototype.sort = sort;
//tools.prototype.ksort = ksort;
//tools.prototype.serialize = serialize;
//tools.prototype.wordwrap = wordwrap;

tools.prototype.uuid = uuid;
tools.prototype.orderCode = orderCode; //tools.prototype.jhid = jhid;

tools.prototype.transTree = transTree;
tools.prototype.transTree2 = transTree2;
tools.prototype.clone = _cloneDeep.default;
tools.prototype.type = type;
tools.prototype.translateScalars = translateScalars;
tools.prototype.mime2type = mime2type;
tools.prototype.base64ToBlob = base64ToBlob;
tools.prototype.resize = resize;
tools.prototype.price = price; //tools.prototype.dencrypt = dencrypt;
//tools.prototype.count = count;

tools.prototype.isEqual = function (x, y) {
  // If both x and y are null or undefined and exactly the same
  if (x === y) {
    return true;
  } // If they are not strictly equal, they both need to be Objects


  if (!(x instanceof Object) || !(y instanceof Object)) {
    return false;
  } //They must have the exact same prototype chain,the closest we can do is
  //test the constructor.


  if (x.constructor !== y.constructor) {
    return false;
  }

  for (var p in x) {
    //Inherited properties were tested using x.constructor === y.constructor
    if (x.hasOwnProperty(p)) {
      // Allows comparing x[ p ] and y[ p ] when set to undefined
      if (!y.hasOwnProperty(p)) {
        return false;
      } // If they have the same strict value or identity then they are equal


      if (x[p] === y[p]) {
        continue;
      } // Numbers, Strings, Functions, Booleans must be strictly equal


      if (typeof x[p] !== "object") {
        return false;
      } // Objects and Arrays must be tested recursively


      if (!Object.equals(x[p], y[p])) {
        return false;
      }
    }
  }

  for (p in y) {
    // allows x[ p ] to be set to undefined
    if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
      return false;
    }
  }

  return true;
}; //var formatRegExp = /%[sdj%]/g;
//tools.prototype.format = function format(f) {
//    if (!is_string(f)) {
//        var objects = [];
//        for (var i = 0; i < arguments.length; i++) {
//            objects.push(inspect(arguments[i]));
//        }
//        return objects.join(' ');
//    }
//
//    var i = 1;
//    var args = arguments;
//    var len = args.length;
//    var str = String(f).replace(formatRegExp, function (x) {
//        if (x === '%%') return '%';
//        if (i >= len) return x;
//        switch (x) {
//            case '%s':
//                return String(args[i++]);
//            case '%d':
//                return Number(args[i++]);
//            case '%j':
//                try {
//                    return JSON.stringify(args[i++]);
//                } catch (_) {
//                    return '[Circular]';
//                }
//            default:
//                return x;
//        }
//    });
//    for (var x = args[i]; i < len; x = args[++i]) {
//        if (is_null(x) || !is_object(x)) {
//            str += ' ' + x;
//        } else {
//            str += ' ' + inspect(x);
//        }
//    }
//    return str;
//};


tools.prototype.http = function (url, data, options) {
  var request = new _request.default();
  return request.url(url).data(data).options(options);
};

tools.prototype.get = function (url, data, options) {
  var request = new _request.default();
  return request.get(url).data(data).options(options);
};

tools.prototype.post = function (url, data, options) {
  var request = new _request.default();
  return request.post(url).data(data).options(options);
};

tools.prototype.put = function (url, data, options) {
  var request = new _request.default();
  return request.put(url).data(data).options(options);
};

tools.prototype.delete = function (url, data, options) {
  var request = new _request.default();
  return request.delete(url).data(data).options(options);
};

tools.prototype.patch = function (url, data, options) {
  var request = new _request.default();
  return request.patch(url).data(data).options(options);
};

tools.prototype.jsonp = function (url, data, options) {
  var request = new _request.default();
  return request.jsonp(url).data(data).options(options);
};
/**
 *
 * @type {storage}
 */
//tools.prototype.storage = new function () {
//
//    var storage = {};
//
//    this.setItem = function (name, params, data) {
//        ksort(params || {}, 'SORT_STRING');
//        var key = name + '?' + http_build_query(params);
//        if (window.plus) {
//            storage.setItem(key, JSON.stringify(data));
//        }
//        else {
//            storage[key] = data;
//        }
//        window.appContext.emit('Cache', name, params, data);
//    }
//
//    this.getItem = function (name, params) {
//        ksort(params || {}, 'SORT_STRING');
//        var key = name + '?' + http_build_query(params);
//        return storage[key];
//    }
//}


tools.prototype.session = function (name, data, expired) {
  if (expired === void 0) {
    expired = 86400;
  }

  var Storage = window.sessionStorage;

  if (name && data && expired != null) {
    var cache = {
      data: data,
      expired: expired ? (0, _time.default)() + expired : 0
    };
    Storage.setItem(name, JSON.stringify(cache));
  } else if (name) {
    try {
      var _cache = JSON.parse(Storage.getItem(name));

      if (_cache.expired === 0) return _cache.data;

      if (_cache && _cache.expired > (0, _time.default)()) {
        return _cache.data;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
};

tools.prototype.cache = function (name, data, expired) {
  if (expired === void 0) {
    expired = 86400;
  }

  var Storage = window.localStorage;

  if (name && data !== undefined && expired != null) {
    var cache = {
      data: data,
      expired: expired ? (0, _time.default)() + expired : 0
    };
    Storage.setItem(name, JSON.stringify(cache));
  } else if (name) {
    try {
      var _cache2 = JSON.parse(Storage.getItem(name));

      if (_cache2.expired === 0) return _cache2.data;

      if (_cache2 && _cache2.expired > (0, _time.default)()) {
        return _cache2.data;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
};

tools.prototype.collide = function collide(rect1, rect2) {
  var maxX, maxY, minX, minY;
  maxX = Math.max(rect1.left + rect1.width, rect2.left + rect2.width);
  maxY = Math.max(rect1.top + rect1.height, rect2.top + rect2.height);
  minX = Math.min(rect1.left, rect2.left);
  minY = Math.min(rect1.top, rect2.top);

  if (maxX - minX <= rect1.width + rect2.width && maxY - minY <= rect1.height + rect2.height) {
    return true;
  } else {
    return false;
  }
}; //var attrs = `accept acceptCharset accessKey action allowFullScreen allowTransparency alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge charSet checked cite classID className colSpan cols content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name noValidate nonce open optimum pattern placeholder poster preload profile radioGroup readOnly rel required reversed role rowSpan rows sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur DOMEventTarget relatedTarget onChange onInput onSubmit onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp`.split(' ');
//
//tools.prototype.pick = function (current, arr) {
//    arr = arr ? arr : {};
//    var obj = {};
//
//    attrs.forEach((key) => {
//        if (current[key])
//            obj[key] = current[key];
//    });
//
//
//    if (arr.forEach) {
//        arr.forEach((key) => {
//            if (current[key])
//                obj[key] = current[key];
//        });
//    }
//    else {
//        for (var key in arr) {
//            if (current[key])
//                obj[key] = current[key];
//        }
//    }
//
//
//    return obj;
//}


var _tools = new tools();

var _default = _tools;
exports.default = _default;
module.exports = exports.default;